module.exports = __webpack_public_path__ + "img/caigou_bg_banner.min.a44d00e8.jpg";